export const downloadFile = (response, fileName) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const downloadFileURL = (url, fileName) => {
  fetch(url, { method: 'get' })
    .then(function (response) {
      return response.blob();
    })
    .then(function (miBlob) {
      var url = URL.createObjectURL(miBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    });
};
